import { useMutation } from "@tanstack/react-query"
import axios from "axios"

const usePostBioFormData = () => {
    return useMutation(async (payload: { user: { email: string, phone: string | null, dob: string }, answers: any }) => {
        const res = await axios.post(`${process.env.NEXT_PUBLIC_API_URL}/api/method/bonatra.bonatra_health_care.doctype.biological_form.biological_form.calculate_biological_age`, {
            ...payload
        }, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        })
        return res
    })
}

export default usePostBioFormData